// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hH5Dn","left":"styles_left__3afea","desktopActions":"styles_desktopActions__2-UcP","title":"styles_title__20S-j"};